<template>
  <form @submit.prevent="validateBeforeSubmit">
    <b-field grouped>
      <b-field
        label="Placa*"
        expanded
        :type="{ 'is-danger': errors.has('registrationPlate') }"
        :message="errors.first('registrationPlate')"
      >
        <b-input
          expanded
          name="registrationPlate"
          v-model="data.registrationPlate"
          maxlength="8"
          :has-counter="false"
          v-validate="'required'"
          data-vv-as="placa"
          v-cleave="masks.registrationPlate"
          :disabled="isEdit"
          @input.native="
            cleaveRefresh($event, {
              condition: value =>
                !isNaN(value[4]) ? 'registrationPlate' : 'mercosulPlate'
            })
          "
        />
      </b-field>

      <b-field
        label="Descrição"
        expanded
        :type="{ 'is-danger': errors.has('description') }"
        :message="errors.first('description')"
      >
        <b-input v-model="data.description" name="description" />
      </b-field>
    </b-field>
    <b-field grouped>
      <b-field
        label="Localização"
        expanded
        :type="{ 'is-danger': errors.has('place') }"
        :message="errors.first('place')"
      >
        <b-input v-model="data.place" name="place" />
      </b-field>
      <b-field
        label="Código interno"
        expanded
        :type="{ 'is-danger': errors.has('externalCode') }"
        :message="errors.first('externalCode')"
      >
        <b-input v-model="data.externalCode" name="externalCode" />
      </b-field>
    </b-field>

    <hr />
    <div class="buttons is-right">
      <router-link class="button is-rounded" :to="'/veiculos'"
        >Voltar</router-link
      >
      <button
        class="button is-rounded is-primary"
        type="submit"
        @click.prevent="validateAndSubmit"
      >
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";

export default {
  props: {
    data: Object,
    isEdit: Boolean,
  },
  directives: {
    cleave
  },
  data() {
    return {
      masks,
      cleaveRefresh,
      restrictions: []
    };
  },
  mounted() {},
  methods: {
    validateAndSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("save", this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      });
    },
    getRawData() {
      const rawData = { ...this.data };

      rawData.document = this.getUnformattedNumber(rawData.document);
      rawData.zipCode = this.getUnformattedNumber(rawData.zipCode);

      return rawData;
    },
    getUnformattedNumber(value) {
      if (value) return value.match(/\d+/g).join("");
    },
  }
};
</script>
